export default function Card({ children, className, exibir=true, id }) {
    return (
        <div id={id} className={`${exibir && "rounded-2xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.20)]"} bg-neutras-white  ${className}`}>
            {children}
        </div>
      );
}